import { render } from "./TotalNbiotDevices.vue?vue&type=template&id=6a85a8c8&scoped=true&ts=true"
import script from "./TotalNbiotDevices.vue?vue&type=script&lang=ts"
export * from "./TotalNbiotDevices.vue?vue&type=script&lang=ts"

import "./TotalNbiotDevices.vue?vue&type=style&index=0&id=6a85a8c8&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a85a8c8"]])

export default __exports__